import * as React from "react";
import { TextBoxEditor } from "../../../../../../../react-core/Html/TextBoxEditor";
import { ButtonLabels, OrganisationMemberPopUpInfo } from "../../Resource/Contents";
import { IAddClientModel, Journey } from "../AddClientWizard";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../Shared/Process/Process/ProcessComponent";
import { CustomerType } from "../../../../../../../Wrap/Constants/Enums/Customer/CustomerType";
import { Accordion } from "../../../../../../../react-core/Html/Accordion";
import { TrustMemberDetails } from "./TrustMemberDetails";
import { CircleBtn, CircleBtnType } from "../../../../../../../react-core/Html/CircleBtn";
import { Lightbox, LightboxType } from "../../../../../../../react-core/Html/Components/Lightbox";
import { RelationshipType } from "../../../../../../../Wrap/Constants/Enums/Customer/RelationshipType";
import { BeneficiaryDetail } from "./BeneficiaryDetail";
import { OrganisationMember } from "../../../../../../../Wrap/Models/Models/Customer/OrganisationMember";
import { PhysicalAddressType } from "../../../../../../../Wrap/Constants/Enums/Customer/PhysicalAddressType";
import { CountryCode } from "../../../../../../../Wrap/Constants/Enums/Domain/CountryCode";

interface ITrustMemberProps extends IProcessComponentProps {
    data: IAddClientModel;
    onSubmit: (journeyType: Journey) => void;
    onPrevious: () => void;
    onlyTrustMember?: boolean;
    existingMembers?: OrganisationMember[];
    disableSettlorOption?: boolean;
    disableBeneficiaryOption?: boolean;
    disableCorporateTrusteeOption?: boolean;
}

interface ITrustMemberState {
    AddNewCustomer: boolean;
    SearchValue: string;
    isOpen: boolean;
    showErrorMsg: any;
    expandList: boolean[];
    showInfoPopUp: boolean;
    fullClients: any[];
    showBeneficiaryPopUp: boolean;
    showSettlorPopUp: boolean;
    journeyType: Journey;
}

export class TrustMember extends ProcessComponent<ITrustMemberProps, ITrustMemberState> {
    constructor(props: ITrustMemberProps) {
        super(props);
        this.state = {
            isOpen: false,
            AddNewCustomer: null,
            SearchValue: null,
            showErrorMsg: null,
            expandList: [],
            showInfoPopUp: false,
            fullClients: [],
            showBeneficiaryPopUp: false,
            showSettlorPopUp: false,
            journeyType: null,
        };
    }

    componentDidMount() {
        super.componentDidMount();
        this.addTrustMember();
    }

    private isContainsCorporateTrustee;

    isValid() {
        const { data, existingMembers } = this.props;
        let isValid = super.isValid();
        const msg = [];
        let isForeignAddress = false;
        if (
            this.containsRelationship(RelationshipType.IndividualTrustee) == false &&
            this.containsRelationship(RelationshipType.CorporateTrustee) == false
        ) {
            msg.push(OrganisationMemberPopUpInfo.atLeastOneTrustee);
            isValid = false;
        }
        if (
            data?.Organisation?.OrganisationMembers?.concat(existingMembers || [])?.filter((x) =>
                x.Relationships.includes(RelationshipType.Settlor)
            ).length > 2
        ) {
            msg.push(OrganisationMemberPopUpInfo.moreThanTwoSettlors);
            isValid = false;
        }
        if (
            data?.Organisation?.OrganisationMembers?.concat(existingMembers || [])?.filter((x) =>
                x.Relationships.includes(RelationshipType.Settlor)
            ).length == 0 &&
            data?.Organisation?.IsNewTrust == true
        ) {
            msg.push(OrganisationMemberPopUpInfo.atLeastOneSettlor);
            isValid = false;
        }

        this.containsCorporateTrustee(data);
        if (this.isContainsCorporateTrustee == false) {
            data?.Organisation?.OrganisationMembers?.map((x) => {
                x.Individual?.AddressDetails?.map((y) => {
                    if (
                        y.PhysicalAddressType == PhysicalAddressType.Residential &&
                        y.Address?.Country != CountryCode.GBR
                    ) {
                        isForeignAddress = true;
                    }
                });
            });
        } else {
            data?.Organisation?.OrganisationMembers?.map((x) => {
                x.Individual?.AddressDetails?.map((y) => {
                    if (
                        y.PhysicalAddressType == PhysicalAddressType.Registered &&
                        y.Address?.Country != CountryCode.GBR
                    ) {
                        isForeignAddress = true;
                    }
                });
            });
        }
        if (isForeignAddress) {
            msg.push(OrganisationMemberPopUpInfo.nonUKResidence);
            isValid = false;
        }

        this.props.showErrorMsgPopUp(msg, true);
        return isValid;
    }

    private containsCorporateTrustee(data) {
        data?.Organisation?.OrganisationMembers?.map((x) => {
            x.Relationships.map((y) => {
                if (y == RelationshipType.CorporateTrustee) {
                    this.isContainsCorporateTrustee = true;
                } else {
                    this.isContainsCorporateTrustee = false;
                }
            });
        });
    }

    private containsRelationship(relationship: RelationshipType) {
        const { data, existingMembers } = this.props;
        let containsTrustee = false;
        if (
            relationship == RelationshipType.Beneficiary &&
            data?.Organisation?.Beneficiaries &&
            data?.Organisation?.Beneficiaries.length > 0
        ) {
            return true;
        }
        const all = (existingMembers || []).concat(data?.Organisation?.OrganisationMembers || []);
        if (!all && all.length < 1) {
            return false;
        }
        all.forEach((member) => {
            if (member.Relationships?.includes(relationship)) {
                containsTrustee = true;
            }
        });
        return containsTrustee;
    }

    private checkMemberValidation() {
        const organisation = this.props.data?.Organisation;
        const length = organisation.OrganisationMembers.length;
        if (length == 0) {
            return true;
        } else if (
            organisation.OrganisationMembers[length - 1].Relationships?.length == 0 ||
            (organisation.OrganisationMembers[length - 1].Company == null &&
                organisation.OrganisationMembers[length - 1].Individual == null)
        ) {
            this.props.showErrorMsgPopUp(["Please complete client details"], true);
            return false;
        } else if (
            (!organisation.OrganisationMembers[length - 1].Relationships.includes(RelationshipType.CorporateTrustee) &&
                organisation.OrganisationMembers[length - 1]?.Individual?.AddressDetails?.filter(
                    (y) => y.PhysicalAddressType == PhysicalAddressType.Residential
                )[0]?.Address?.Country != CountryCode.GBR) ||
            (organisation.OrganisationMembers[length - 1].Relationships.includes(RelationshipType.CorporateTrustee) &&
                organisation.OrganisationMembers[length - 1]?.Company?.AddressDetails?.filter(
                    (y) => y.PhysicalAddressType == PhysicalAddressType.Registered
                )[0]?.Address?.Country != CountryCode.GBR)
        ) {
            this.props.showErrorMsgPopUp([OrganisationMemberPopUpInfo.nonUKResidence], true);
            return false;
        } else {
            return true;
        }
    }

    private addTrustMember() {
        const { data, onChange } = this.props;
        const organisation = data?.Organisation;

        if (
            organisation.OrganisationMembers &&
            organisation.OrganisationMembers.length > 0 &&
            (this.isValidChild(organisation.OrganisationMembers.length - 1) == false || !this.checkMemberValidation())
        ) {
            return;
        }
        this.onAddMember();
    }

    private onAddMember() {
        const { data, onChange } = this.props;
        const organisation = data?.Organisation;
        const { expandList, fullClients } = this.state;

        const _members = organisation?.OrganisationMembers ? organisation?.OrganisationMembers.concat() : [];
        _members.push({
            Company: null,
            Individual: null,
            Relationships: [],
            Percentage: 0,
        });
        this.onDataChange(onChange, { OrganisationMembers: _members }, data, "Organisation");

        expandList[expandList.length - 1] = false;
        expandList.push(true);
        const _fullClients = fullClients;
        _fullClients.push({});
        this.setState({ expandList: expandList, fullClients: _fullClients });
    }

    private onRemoveMember(i) {
        const { data, onChange } = this.props;
        const { expandList, fullClients } = this.state;
        const _data = data?.Organisation?.OrganisationMembers.concat();
        _data.splice(i, 1);
        expandList.splice(i, 1);
        this.onDataChange(onChange, { OrganisationMembers: _data }, data, "Organisation");
        fullClients.splice(i, 1);
        this.setState({ expandList: expandList, fullClients: fullClients });
    }

    private onMemberChange(changes, i) {
        const { data, onChange } = this.props;
        const _data = data?.Organisation?.OrganisationMembers.concat();
        const _item = _data[i];
        for (const key in changes) {
            _item[key] = changes[key];
        }
        _data[i] = _item;
        this.onDataChange(onChange, { OrganisationMembers: _data }, data, "Organisation");
    }

    private onClickSubmit(journeyType: Journey) {
        this.props.onSubmit(journeyType);
    }

    private validateBeforeSubmit(journeyType: Journey) {
        let flag = this.isValid() && this.checkMemberValidation();
        if (flag) {
            const { data } = this.props;
            const settlorNum = data?.Organisation?.OrganisationMembers?.filter((x) =>
                x.Relationships.includes(RelationshipType.Settlor)
            ).length;
            const trusteeNum = data?.Organisation?.OrganisationMembers?.filter(
                (x) =>
                    x.Relationships.includes(RelationshipType.IndividualTrustee) ||
                    x.Relationships.includes(RelationshipType.CorporateTrustee)
            ).length;

            if (!this.containsRelationship(RelationshipType.Beneficiary)) {
                this.setState({ showBeneficiaryPopUp: true, journeyType: journeyType });
                flag = false;
            }
            if (trusteeNum <= settlorNum) {
                this.setState({ showSettlorPopUp: true, journeyType: journeyType });
                flag = false;
            }
            if (settlorNum == 0 && data?.Organisation?.IsNewTrust == true) {
                this.setState({ journeyType: journeyType });
                flag = false;
            }
            if (flag) {
                this.onClickSubmit(journeyType);
            }
        }
        return flag;
    }

    render() {
        const {
            data,
            existingMembers,
            disableBeneficiaryOption,
            disableSettlorOption,
            disableCorporateTrusteeOption,
        } = this.props;
        const beneficiaryNum = data?.Organisation?.Beneficiaries ? data?.Organisation?.Beneficiaries.length : 0;
        const organisationMemberNum = data?.Organisation?.OrganisationMembers
            ? data?.Organisation?.OrganisationMembers.length
            : 0;

        const memberNum = beneficiaryNum + organisationMemberNum + ((existingMembers || []).length || 0);
        return (
            <>
                <div className="mb-10">
                    <a
                        href="javascript:void(0);"
                        className="hyperlink"
                        onClick={() => this.setState({ showInfoPopUp: true })}
                    >
                        Trust members explained.
                    </a>
                </div>

                {this.state.showInfoPopUp && (
                    <Lightbox
                        show={this.state.showInfoPopUp}
                        title={"Trust member explained"}
                        contentAfterTitle={null}
                        onClose={() => this.setState({ showInfoPopUp: false })}
                        type={LightboxType.Modal}
                        unclosable={true}
                        noOverlay={false}
                        noAutofocus={true}
                        cssWrapper="is-default-lightbox"
                    >
                        <p>{OrganisationMemberPopUpInfo.moreTrusteesThanSettlors}</p>
                        <p>{OrganisationMemberPopUpInfo.line2}</p>
                        <p>{OrganisationMemberPopUpInfo.line3}</p>
                        <p>{OrganisationMemberPopUpInfo.line4}</p>
                        <button className="btn primary" onClick={() => this.setState({ showInfoPopUp: false })}>
                            Close
                        </button>
                    </Lightbox>
                )}
                {(this.state.showBeneficiaryPopUp || this.state.showSettlorPopUp) && (
                    <Lightbox
                        show={this.state.showBeneficiaryPopUp || this.state.showSettlorPopUp}
                        title={"Trust members explained"}
                        contentAfterTitle={null}
                        onClose={() =>
                            this.setState({
                                showBeneficiaryPopUp: false,
                                showSettlorPopUp: false,
                            })
                        }
                        type={LightboxType.Modal}
                        unclosable={true}
                        noOverlay={false}
                        noAutofocus={true}
                        cssWrapper="is-default-lightbox"
                    >
                        {this.state.showBeneficiaryPopUp && <p>{OrganisationMemberPopUpInfo.noBeneficiary}</p>}
                        {this.state.showSettlorPopUp && <p>{OrganisationMemberPopUpInfo.moreTrusteesThanSettlors}</p>}

                        <p>{OrganisationMemberPopUpInfo.addMoreTrust}</p>
                        <div className="row">
                            <button
                                className="btn primary mr-10"
                                onClick={() => {
                                    this.setState({
                                        showBeneficiaryPopUp: false,
                                        showSettlorPopUp: false,
                                    });
                                }}
                            >
                                Yes
                            </button>
                            <button
                                className="btn secondary"
                                onClick={() => {
                                    this.onClickSubmit(this.state.journeyType);
                                }}
                            >
                                No
                            </button>
                        </div>
                    </Lightbox>
                )}
                {!this.props.onlyTrustMember && (
                    <TextBoxEditor
                        cssWrapper="control-size-430"
                        value={data?.Organisation.Name}
                        disabled={true}
                        label={data.CustomerType == CustomerType.Trust ? "Trust name" : "Name"}
                    />
                )}

                {data?.Organisation?.OrganisationMembers &&
                    data?.Organisation?.OrganisationMembers.map((ele, index) => {
                        return (
                            <Accordion
                                key={`New member - ${index + 1}`}
                                label={`Member - ${index + 1}`}
                                cssWrapper="accordion-simple"
                                onChange={(v) => (v ? true : this.isValidChild(index))}
                                isOpen={this.state.expandList[index]}
                            >
                                <TrustMemberDetails
                                    onRef={(ref) => {
                                        this.appendChild(ref, index);
                                    }}
                                    data={ele}
                                    onChange={(change) => this.onMemberChange(change, index)}
                                    onSubmit={() => {}}
                                    customerType={this.props.data.CustomerType}
                                    lawToApply={data?.Organisation?.LawToApply}
                                    ownerAdviserId={data?.Organisation.OwnerAdviserId}
                                    showErrorMsgPopUp={(msg, showNow) => this.props.showErrorMsgPopUp(msg, showNow)}
                                    selectedCustomers={data?.Organisation?.OrganisationMembers.map((x) => x.CustomerId)}
                                    disableSettlorOption={
                                        disableSettlorOption || this.props.data?.Organisation?.IsNewTrust == false
                                    }
                                    disableBeneficiaryOption={disableBeneficiaryOption}
                                    disableCorporateTrusteeOption={
                                        disableCorporateTrusteeOption ||
                                        (data?.Organisation?.OrganisationMembers.some((x) =>
                                            x?.Relationships?.includes(RelationshipType.CorporateTrustee)
                                        ) &&
                                            data?.Organisation?.OrganisationMembers.findIndex((x) =>
                                                x?.Relationships?.includes(RelationshipType.CorporateTrustee)
                                            ) != index)
                                    }
                                    existingMembers={existingMembers}
                                />
                                <CircleBtn
                                    type={CircleBtnType.remove}
                                    cssWrapper="mr-52"
                                    title="Remove this member"
                                    onClick={() => this.onRemoveMember(index)}
                                />
                            </Accordion>
                        );
                    })}
                {memberNum < 20 && (
                    <CircleBtn
                        type={CircleBtnType.add}
                        title="Add another member"
                        onClick={() => this.addTrustMember()}
                    />
                )}
                <hr className="mt-40 mb-20" />

                {!this.props.onlyTrustMember && (
                    <>
                        <BeneficiaryDetail
                            data={data?.Organisation?.Beneficiaries}
                            onRef={(ref) => this.appendChild(ref)}
                            onChange={(changes) =>
                                this.onDataChange(this.props.onChange, { Beneficiaries: changes }, data, "Organisation")
                            }
                            showErrorMsgPopUp={(msg, showNow) => this.props.showErrorMsgPopUp(msg, showNow)}
                            memberNumber={memberNum}
                            ownerAdviserId={data?.Organisation.OwnerAdviserId}
                        />
                        <hr className="mt-40 mb-20" />

                        <div className="page-actions">
                            <div className="action-secondary">
                                <button
                                    onClick={() => {
                                        this.props.onPrevious();
                                    }}
                                    className="prev-button"
                                >
                                    <span aria-hidden="true" className="icon"></span>
                                    <span className="text">{ButtonLabels.previousLabel}</span>
                                </button>
                            </div>
                            <div className="action-primary">
                                <div className="primary-dropdown">
                                    <button
                                        className="trigger"
                                        aria-expanded={this.state.isOpen}
                                        aria-haspopup="true"
                                        onClick={() =>
                                            this.updateStatePart((x) => {
                                                x.isOpen = !this.state.isOpen;
                                            })
                                        }
                                    >
                                        <span className="text">{ButtonLabels.nextLabel}</span>
                                        <span className="icon" aria-hidden="true"></span>
                                    </button>
                                    {this.state.isOpen && (
                                        <div className="dropdown-list a-dropdown-enter-done">
                                            <div className="dropdown-list-panel">
                                                <div
                                                    className="item"
                                                    onClick={() => {
                                                        this.validateBeforeSubmit(Journey.AddClient);
                                                    }}
                                                >
                                                    {ButtonLabels.addClient}
                                                </div>
                                                <div
                                                    className="item"
                                                    onClick={() => {
                                                        this.validateBeforeSubmit(Journey.NewTrust);
                                                    }}
                                                >
                                                    {ButtonLabels.newBusiness}
                                                </div>
                                                <div
                                                    className="item"
                                                    onClick={() => {
                                                        this.validateBeforeSubmit(Journey.CreateAnotherClient);
                                                    }}
                                                >
                                                    {ButtonLabels.createAnotherClient}
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </>
                )}
            </>
        );
    }
}
